import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { ADVERTISEMENTS_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const updateAdvertisementDisplayTimeAction = createAsyncThunk(
    'pod/updateAdvertisementDisplayTimeAction',
    async (data, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.patch(`${ ADVERTISEMENTS_PATH }/${ data.id }/display-time`, data.form);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const updateAdvertisementDisplayTimeSlice = createSlice({
    name: 'updateAdvertisementDisplayTimeSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(updateAdvertisementDisplayTimeAction.pending, () => STATE__API__STARTED);
        builder.addCase(updateAdvertisementDisplayTimeAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(updateAdvertisementDisplayTimeAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const updateAdvertisementDisplayTimeState = (state) => state.pod.updateAdvertisementDisplayTime;
export default updateAdvertisementDisplayTimeSlice.reducer;